<script setup>
// Shared frame for all embedded widgets. The "Powered by Tap Leagues" footer is
// part of the product - it renders in every state and must not be removable.
defineProps({
  title: {type: String, default: ''},
  clubName: {type: String, default: null},
});
</script>

<template>
  <div class="ws-card">
    <div class="ws-header">
      <div class="ws-title">{{ title }}</div>
      <div v-if="clubName" class="ws-club">{{ clubName }}</div>
    </div>
    <div class="ws-body">
      <slot />
    </div>
    <a
        class="ws-footer"
        href="https://tapleagues.com?utm_source=widget"
        target="_blank"
        rel="noopener"
    >
      <span>Powered by</span>
      <img src="/logo.png" alt="Tap Leagues" class="ws-footer-logo" />
    </a>
  </div>
</template>

<style scoped lang="scss">
.ws-card {
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 12px;
  overflow: hidden;
  color: #1a1a1a;
}

.ws-header {
  padding: 14px 16px 12px;
  border-bottom: 2px solid var(--tl-widget-primary, #d32946);
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.ws-title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
}

.ws-club {
  font-size: 12px;
  color: #6b6b6b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ws-body {
  min-height: 40px;
}

.ws-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  border-top: 1px solid #ececec;
  background: #fafafa;
  text-decoration: none;
  color: #9b9b9b;
  font-size: 11px;
}

.ws-footer-logo {
  height: 14px;
  width: auto;
  display: block;
}
</style>
